var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      directives: [
        {
          name: "show",
          rawName: "v-show",
          value: _vm.modalShown,
          expression: "modalShown"
        }
      ],
      staticClass: "modal",
      attrs: { id: "support-modal" }
    },
    [
      _c("dd-loading-modal", { ref: "loadingModalRef" }),
      _vm._v(" "),
      _c("div", { staticClass: "modal-main" }, [
        _vm._m(0),
        _vm._v(" "),
        _c("div", { staticClass: "data-area" }, [
          _c("ul", [
            _c("li", [
              _c("span", { staticClass: "label" }, [
                _vm._v("お問い合わせ区分")
              ]),
              _vm._v(" "),
              _c(
                "select",
                {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model.number",
                      value: _vm.type,
                      expression: "type",
                      modifiers: { number: true }
                    }
                  ],
                  on: {
                    change: function($event) {
                      var $$selectedVal = Array.prototype.filter
                        .call($event.target.options, function(o) {
                          return o.selected
                        })
                        .map(function(o) {
                          var val = "_value" in o ? o._value : o.value
                          return _vm._n(val)
                        })
                      _vm.type = $event.target.multiple
                        ? $$selectedVal
                        : $$selectedVal[0]
                    }
                  }
                },
                _vm._l(_vm.typeList, function(type, index) {
                  return _c(
                    "option",
                    { key: index, domProps: { value: type.num } },
                    [_vm._v(_vm._s(type.code))]
                  )
                })
              ),
              _vm._v(" "),
              _c("div", { staticClass: "error_message" }, [
                _vm._v(_vm._s(_vm.fieldErrorMessages.type))
              ])
            ]),
            _vm._v(" "),
            _c("li", [
              _c("span", { staticClass: "label" }, [_vm._v("件名")]),
              _vm._v(" "),
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.title,
                    expression: "title"
                  }
                ],
                attrs: { type: "text" },
                domProps: { value: _vm.title },
                on: {
                  input: function($event) {
                    if ($event.target.composing) {
                      return
                    }
                    _vm.title = $event.target.value
                  }
                }
              }),
              _vm._v(" "),
              _c("div", { staticClass: "error_message" }, [
                _vm._v(_vm._s(_vm.fieldErrorMessages.title))
              ])
            ]),
            _vm._v(" "),
            _c("li", [
              _c("span", { staticClass: "label support_body_pos" }, [
                _vm._v("お問い合わせ内容")
              ]),
              _vm._v(" "),
              _c("textarea", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.body,
                    expression: "body"
                  }
                ],
                attrs: { rows: "10", maxlength: "256" },
                domProps: { value: _vm.body },
                on: {
                  input: function($event) {
                    if ($event.target.composing) {
                      return
                    }
                    _vm.body = $event.target.value
                  }
                }
              }),
              _vm._v(" "),
              _c("div", { staticClass: "error_message" }, [
                _vm._v(_vm._s(_vm.fieldErrorMessages.body))
              ])
            ])
          ])
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "button-area" }, [
          _c(
            "button",
            {
              staticClass: "main_btn",
              attrs: { type: "button" },
              on: { click: _vm.onTransmit }
            },
            [_vm._v("送信")]
          ),
          _vm._v(" "),
          _c(
            "button",
            {
              staticClass: "main_btn",
              attrs: { type: "button" },
              on: { click: _vm.closeModal }
            },
            [_vm._v("キャンセル")]
          )
        ])
      ])
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "title-area" }, [
      _c("h2", [_vm._v("お問い合わせフォーム")])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-6a41a0b2", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6a41a0b2","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/main/js/components/common/SupportModal.vue
// module id = null
// module chunks = 